jQuery(document).ready(function () {
  // FAQ Functionality

  $(".faq-accordian").on("click", function () {
    // Toggle active class
    $(this).toggleClass("active");

    // Slide toggle the panel
    var panel = $(this).next(".panel");

    // Optional: Close others
    $(".faq-accordian")
      .not(this)
      .removeClass("active")
      .next(".panel")
      .slideUp();

    panel.stop(true, true).slideToggle();
  });

  function toggleMenu() {
    if ($(window).width() <= 768) {
      $(".footer__content-top .footer-block__heading")
        .off("click")
        .on("click", function () {
          $(this).next(".footer-block__details-content").slideToggle(300);
          $(this).parent().toggleClass("open");
        });
    } else {
      $(".footer-block__details-content").show(); // Ensure menu stays visible on large screens
    }
  }

  toggleMenu(); // Run initially
  $(window).resize(toggleMenu); // Run when window resizes
  $(".price-item--sale").each(function () {
    $(this).text($(this).text().replace("From", ""));
  });

  // Header on mobile

  $(".header__icon--menu").click(function () {
    var wrap_index = $(".fullscreen-video-wrap");
    var overlay_index = $(".overlay");
    var videoBoxInfo_index = $(".videoBoxInfo");
    $(wrap_index).toggleClass("removeIndex");
    $(overlay_index).toggleClass("removeIndex");
    $(videoBoxInfo_index).toggleClass("removeIndex");
  });

  // Open Mega menu on hover

  $(".list-menu--inline li").hover(
    function () {
      $(".open-submenu", this).attr("open", "open");
      $(".open-submenu details", this).attr("open", "open");
    },
    function () {
      $(".open-submenu", this).removeAttr("open");
    }
  );

  // Back to Top Button

  $(window).scroll(function () {
    if ($(this).scrollTop() > 20) {
      $("#toTopBtn").show();
    } else {
      $("#toTopBtn").hide();
    }
  });

  $("#toTopBtn").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000
    );
    return false;
  });

  $(window).scroll(function () {
    if (
      $(document).height() - $(window).height() - $(window).scrollTop() ==
      0
    ) {
      $("#toBottomBtn").fadeOut();
    } else {
      $("#toBottomBtn").fadeIn();
    }
  });

  $("#toBottomBtn").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(document).height(),
      },
      1000
    );
    return false;
  });

  // Hijab style video Close button functionality

  $(".close-video").click(function () {
    $(this).hide();
    $(".video-img-section video").hide();
  });
  // Handle product description sections
//   var description = $(".product__description"),
//     tempContainer = $("<div></div>"),
//     tempSection = $("<section></section>"),
//     isFirst = true,
//     hasPrependedContent = false;

//   if (
//     description.find("h6").length > 0 &&
//     description.find("section").length === 0
//   ) {
//     console.log("Only H6 tags are present!");

//     // Create a separate section for content before the first h6
//     var preH6Content = $("<section></section>").addClass("pre-h6-content");

//     description.children().each(function () {
//       var element = $(this);
//       if (element.is("h6")) {
//         if (!hasPrependedContent) {
//           // Append preH6Content to tempContainer before the first section
//           if (preH6Content.children().length > 0) {
//             tempContainer.append(preH6Content);
//           }
//           hasPrependedContent = true;
//         }
//         if (!isFirst) tempContainer.append(tempSection);
//         var sectionClass = element
//           .text()
//           .replace(/#/g, "")
//           .replace(/\s+/g, "-");
//         tempSection = $("<section></section>")
//           .addClass(sectionClass)
//           .append(element);
//         isFirst = false;
//       } else {
//         if (!hasPrependedContent) {
//           preH6Content.append(element); // Collect content before the first h6
//         } else {
//           tempSection.append(element); // Add subsequent elements to the current section
//         }
//       }
//     });

//     // Append the final sections to tempContainer
//     if (preH6Content.children().length > 0 && !hasPrependedContent) {
//       tempContainer.append(preH6Content);
//     }
//     if (tempSection.children().length > 0) {
//       tempContainer.append(tempSection);
//     }

//     // Update the description HTML
//     description.html(tempContainer.html());
//   }
//   setTimeout(function () {
//     $(".swatch-view-item").each(function () {
//       var getCarreStyle = $(this).attr("orig-value"); // Wrap `this` with $()
//       if (getCarreStyle === "Carré") {
//         $(this).attr("orig-value", "Carre"); // Wrap `this` with $()
//       }
//     });
//   }, 2000); // 2000ms = 2 seconds
//   $(".product__description section").each(function () {
//     var originalClassName = $(this).attr("class"); // Get the class of the section

//     // Check if the class name contains special characters or hyphens
//     if (/[^\w\s-]/.test(originalClassName)) {
//       var getVariantClassName = originalClassName
//         .replace(/[^\w\s]/gi, "") // Remove special characters
//         .replace(/\s+/g, "-") // Replace spaces with hyphens
//         .toLowerCase(); // Convert to lowercase

//       $(this).attr("class", getVariantClassName); // Set the new class name for the current section
//       console.log("Class Name: " + getVariantClassName); // Log the new class name
//     } else {
//       console.log("No change: " + originalClassName); // Log if no changes were made
//     }
//   });

//   // Display Decription On Load
  
//  $(document).ready(function () {
//   setTimeout(function () {
//     $(".swatch-view-item").each(function () {
//       if ($(this).attr("aria-checked") === "true") {
//         console.log("checked aria");
//         var value = $(this)
//           .attr("orig-value")
//           .replace(/[^\w\s]/gi, "")
//           .replace(/\s+/g, "");

//         // Convert to lowercase if not already
//         if (value !== value.toLowerCase()) {
//           value = value.toLowerCase();
//         }

//         console.log("Swatch Name: " + value);

//         var matchingSection = $(".product__description section").filter(function () {
//           var sectionClass = $(this).attr("class");

//           if (!sectionClass) {
//             return false;
//           }

//           if (sectionClass !== sectionClass.toLowerCase()) {
//             sectionClass = sectionClass.toLowerCase();
//           }

//           return sectionClass === value;
//         });

//         if (matchingSection.length > 0) {
//           $(".product__description section").hide();
//           matchingSection.show().find("h6").hide();
//         }
//       }
//     });
//   }, 3000); // Delay in milliseconds (3 seconds)
// });

  // $(document).on("click", ".swatch-view-item", function () {
  //   var value = $(this)
  //     .attr("orig-value")
  //     .replace(/[^\w\s]/gi, "")
  //     .replace(/\s+/g, "");

  //   // Check if the value is not already in lowercase and convert it if necessary
  //   if (value !== value.toLowerCase()) {
  //     value = value.toLowerCase();
  //   }

  //   console.log("Swatch Name: " + value);

  //   var matchingSection = $(".product__description section").filter(
  //     function () {
  //       var sectionClass = $(this).attr("class");

  //       // If the section has no class attribute, skip it
  //       if (!sectionClass) {
  //         return false;
  //       }

  //       // Only convert to lowercase if the class isn't already in lowercase
  //       if (sectionClass !== sectionClass.toLowerCase()) {
  //         sectionClass = sectionClass.toLowerCase();
  //       }

  //       return sectionClass === value;
  //     }
  //   );

  //   if (matchingSection.length > 0) {
  //     $(".product__description section").hide();
  //     matchingSection.show().find("h6").hide();
  //   }
  // });

  // // Populate relevant Variant Images

  // $(document).on("click", ".swatch-view-item", function () {
  //   console.log("Populate Variant Images Function clicked");
  //   var getAttribute = $(this).attr("orig-value");
  //   var attrWithoutChar = getAttribute.replace(/[^\w\s]/gi, "");
  //   console.log("Without Character " + attrWithoutChar);
  //   attrWithoutChar = attrWithoutChar.replace(/\s+/g, "-").toLowerCase();
  //   var updateChar = "#style_" + attrWithoutChar;
  //   console.log("Lowercase " + updateChar);
  //   var productImages = $(".thumbnail-list__item");
  //   for (var i = 0; i < productImages.length; i++) {
  //     var dataGroup = $(productImages[i]).attr("thumbnail-color");
  //     var getVariantAttr = dataGroup ? dataGroup.toLowerCase() : "";
  //     if (getVariantAttr === updateChar) {
  //       $(productImages[i]).show();
  //     } else {
  //       $(productImages[i]).hide();
  //     }
  //   }
  // });

  // Announcement bar popup
  $(".bts-popup-trigger").on("click", function (e) {
    e.preventDefault();
    $(".announcement-bar .bts-popup").addClass("is-visible");
    $(".announcement-bar .bts-popup-trigger").addClass("popup-visible");
  });

  $(".announcement-bar .bts-popup").on("click", function (e) {
    if ($(e.target).is(".bts-popup-close") || $(e.target).is(".bts-popup")) {
      e.preventDefault();
      $(this).removeClass("is-visible");
      $(".announcement-bar .bts-popup-trigger").removeClass("popup-visible");
    }
  });

  // Dropdown navigation redirect
  $(".bts-popup-button").click(function () {
    var selectedValue = $("#storeDropdown").find(":selected").val();
    console.log(selectedValue);
    window.location.href = selectedValue;
  });

  // Manage navigation classes
  var activeSubmenu = $(".nav-collection_image")
    .parent()
    .parent()
    .parent()
    .addClass("active-submenu");
  console.log(activeSubmenu);
  var activeParent = $(".nav-collection_image")
    .parent()
    .parent()
    .parent()
    .parent()
    .addClass("active-parent-submenu");
  console.log(activeParent);

  // Recently viewed items interactivity
  $(".recently-viewed-grid-item a").attr(
    "style",
    "cursor: not-allowed; pointer-events: none;"
  );
  $(window).scroll(function () {
    if ($(window).scrollTop() > 500) {
      $(".recently-viewed-grid-item a").attr(
        "style",
        "cursor: pointer; pointer-events: auto;"
      );
    } else {
      $(".recently-viewed-grid-item a").attr(
        "style",
        "cursor: not-allowed; pointer-events: none;"
      );
    }
  });

  // Handle specific menu item behavior
  var selectedParent = $("#Details-HeaderMenu-2 .nav-collection_image").next();
  console.log(selectedParent);
  selectedParent.hide();
  $("#Details-HeaderMenu-2 .nav-collection_image")
    .parent()
    .attr("href", "/pages/the-complete-hijab-design-style-guide");
});
